import { useState, useEffect, forwardRef, useRef, } from 'react'
import { LinearProgress, Grid, Typography, Card, CardContent, Button, CircularProgress, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Slide, InputLabel, } from '@mui/material';
import Chip from '@mui/material/Chip';
import { toast } from 'react-toastify';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import config from '../config.json';
import { KeyFillDropDown, fetchAttributeValues } from '../functions/helpers/general';
import { handleFormChange } from '../functions/multiDropDown';
import { apiRequest } from '../functions/apiRequest';
import CreatableSelect from 'react-select/creatable';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const centerStyle = { display: 'flex', justifyContent: 'center' };

const options = [
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
    { value: "Sunday", label: "Sunday" }
];

const defaultLocations = [
    {
        value: 'Bengaluru',
        label: 'Bengaluru',
    },
    {
        value: 'Google Meet',
        label: 'Google Meet',
    },
    {
        value: 'Zoom',
        label: 'Zoom',
    },
];



export default function HumanLibrary({ isMobile, localUserData }) {
    // {
    //     "requesterUserId": userID,
    //     "requesteeUserId": allUsers[index].id,
    //     "preferedHoursStart": startTime,
    //     "preferedHoursEnd": endTime,
    //     "preferedDays": selected,
    //     "subjectForDiscussion": reason.current.value,
    //     "hoursRequested": hours,
    //     "meetingLocation": location
    // }
    const initialFormData = Object.freeze({
        requesterUserId: localUserData.id,
        requesteeUserId: "",
        preferedHoursStart: "18:00",
        preferedHoursEnd: "21:00",
        preferedDays: [],
        subjectForDiscussion: "",
        hoursRequested: "1",
        meetingLocation: "Google Meet"
    });
    const [formData, updateFormData] = useState(initialFormData);
    const [open, setOpen] = useState(false)
    const [allUsers, setAllUsers] = useState([]);
    const [index, selectedIndex] = useState(0);
    const [page, setPage] = useState(1);
    const [locations, setLocations] = useState(defaultLocations);
    const isLoading = (false)
    const reason = useRef('');
    const [loading, setLoading] = useState(false);
    const [submitHit, setSubmitHit] = useState(false)

    const handleInput = (e) => {
        updateFormData({
            ...formData,
            // Trimming any whitespace
            [e.target.name]: typeof e.target.value !== 'object' ? e.target.value.trim() : e.target.value,
        });
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleLoadMore = async (increasePage, keyWord = 'none') => {
        let pageNumber

        if (increasePage) {
            setPage(page + 1)
            pageNumber = page + 1
        } else {
            pageNumber = 1
        }

        if (keyWord === '') {
            keyWord = 'none'
        }

        let endPoint = `/api/user/all/${pageNumber}/${keyWord}`
        try {

            let res = await fetch(process.env.REACT_APP_API_URL + endPoint, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${localUserData.token}`,
                },
            })
            let data = await res.json()
            if (increasePage) {
                setAllUsers([...allUsers, ...data])
            } else {
                setAllUsers(data)
            }


        } catch (err) {

            toast.error(err.message);

        }


    }

    const handleSubmit = async () => {
        try {
            setLoading(true);
            let submittedFormData = {
                ...formData,
                subjectForDiscussion: reason.current?.value,
                requesteeUserId: allUsers[index].id
            };
            updateFormData(submittedFormData);
            if (Object.values(submittedFormData).includes("")) {
                setLoading(false);
                setSubmitHit(true);
                throw Error('Please fill all the fields');
            }
            submittedFormData.preferedDays = submittedFormData.preferedDays.map(day => { return day.value });
            const response = await apiRequest('POST', JSON.stringify(submittedFormData), '/humanlibrary/request', localUserData.token, null, null, true)
            setLoading(false)
            setSubmitHit(false);
            handleClose();
            if (!response.data.error) {
                toast.success(`Request sent to ${allUsers[index].first_name}! You will be notified once they accept your request!`)
            } else {
                toast.error(response.data.error);
            }
        } catch (err) {
            console.log(err)
            setLoading(false)
            setSubmitHit(false);
            toast.error(err.message);
        }
    }

    useEffect(() => {
        async function fetchData() {
            if (localUserData && localUserData.token) {
                let response = await apiRequest('GET', null, `/user/all/${page}/none`, localUserData.token, null, null, true)
                setAllUsers(response.data);
                await fetchAttributeValues({ model: 'event', setLocations })
            } else {
                window.location = '/login';
            }
        }
        fetchData();
        // eslint-disable-next-line
    }, [])

    // const RequestTimeDialogBox = (({ handleClose, updateFormData, handleFormChange, handleInput, handleSubmit, open, Transition, locations, options, allUsers, formData, index, submitHit, loading }) => {
    // return <Grid item xs={6} md={12} style={{ boxShadow: '2px 2px 2px black' }}>
    //     <Dialog
    //         open={open}
    //         TransitionComponent={Transition}
    //         maxWidth="md"
    //         BackdropProps={{ style: { backgroundColor: "transparent" } }}
    //         onClose={handleClose} aria-labelledby="simple-dialog-title"
    //     >
    //         <DialogTitle>Request time from
    //             {allUsers[index] && (allUsers[index].first_name !== allUsers[index].last_name ? (` ${allUsers[index].first_name} ${allUsers[index].last_name}`) : (` ${allUsers[index].first_name}`))}?
    //         </DialogTitle>
    //         <DialogContent>
    //             <Grid container spacing={3}>
    //                 <Grid item xs={12} md={12}>
    //                     <TextField
    //                         multiline={true}
    //                         required
    //                         id="reason"
    //                         label="Reason for request"
    //                         defaultValue={formData.reason}
    //                         fullWidth
    //                         value={formData.reason}
    //                         error={(submitHit && !formData.reason) || (submitHit && formData.reason?.length === 0)}
    //                     />
    //                 </Grid>
    //                 <Grid item xs={6} md={6}>
    //                     <InputLabel id="mutiple-select-label">Location</InputLabel>
    //                     <KeyFillDropDown
    //                         options={locations}
    //                         keyName="location"
    //                         formData={formData}
    //                         updateFormData={updateFormData}
    //                         handleFormChange={handleFormChange}
    //                     />
    //                 </Grid>
    //                 <Grid item xs={6} md={6} >
    //                     <InputLabel id="mutiple-select-label">Prefered Days</InputLabel>
    //                     <CreatableSelect
    //                         defaultValue={[]}
    //                         isMulti
    //                         onChange={(e) => { handleInput({ target: { name: 'preferedDays', value: e } }) }}
    //                         options={options}
    //                         value={formData.preferedDays}
    //                         style={{ zIndex: 10000 }}
    //                     />
    //                 </Grid>
    //                 <Grid item xs={4} md={4}>
    //                     <TextField
    //                         required
    //                         label="How many hours?"
    //                         id="outlined-number"
    //                         type="number"
    //                         value={formData.hoursRequested}
    //                         onChange={handleInput}
    //                         error={submitHit && formData.hoursRequested.length === 0}
    //                     />
    //                 </Grid>
    //                 <Grid item xs={4} md={4}>
    //                     <TextField
    //                         id="time"
    //                         label="Prefered Time (Start)"
    //                         type="time"
    //                         defaultValue={formData.preferedHoursStart}
    //                         inputProps={{
    //                             step: 900, // 5 min
    //                         }}
    //                         error={submitHit && formData.preferedHoursStart.length === 0}
    //                         onChange={handleInput}
    //                         style={{ width: '100%' }}
    //                     />
    //                 </Grid>
    //                 <Grid item xs={4} md={4}>
    //                     <TextField
    //                         id="time"
    //                         label="Prefered Time (End)"
    //                         type="time"
    //                         defaultValue={formData.preferedHoursEnd}
    //                         error={submitHit && formData.preferedHoursEnd.length === 0}
    //                         onChange={handleInput}
    //                         inputProps={{
    //                             step: 900, // 5 min
    //                         }}
    //                         style={{ width: '100%' }}
    //                     />
    //                 </Grid>
    //             </Grid>
    //         </DialogContent>
    //         <DialogActions>
    //             <Button
    //                 onClick={handleClose}
    //                 disabled={loading}
    //                 style={{
    //                     height: 40,
    //                     fontFamily: 'Raleway',
    //                     width: '6vw',

    //                     backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
    //                     borderRadius: 30,
    //                     color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
    //                 }}
    //             >
    //                 Cancel
    //             </Button>
    //             <Button
    //                 onClick={handleSubmit}
    //                 disabled={loading}
    //                 style={{
    //                     height: 40,
    //                     fontFamily: 'Raleway',
    //                     width: '6vw',

    //                     backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
    //                     borderRadius: 30,
    //                     color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
    //                 }}
    //             >
    //                 Submit
    //             </Button>
    //             <div hidden={!loading}>
    //                 <CircularProgress color="inherit" />
    //             </div>
    //         </DialogActions>
    //     </Dialog>
    // </Grid>
    // })

    const UserCard = ({ user, idx }) => {
        return <Grid item xs={12} md={4} key={idx}>
            <Card
                key={idx}
                variant='outlined'
                style={{
                    borderRadius: 30,
                    outlineColor: 'black'
                }}
            >
                <CardContent style={{ fontFamily: 'Raleway' }}>
                    <Grid container>
                        <Grid item xs={8} sm={8} md={8}>
                            <Grid container>
                                <Grid item xs={12} md={12}>
                                    <Typography
                                        component='h1'
                                        style={{
                                            fontSize: 22,
                                            fontFamily: 'Raleway',
                                        }}
                                    >
                                        {user.first_name !== user.last_name ?
                                            (<strong>{user.first_name} {user.last_name}</strong>) :
                                            (<strong>{user.first_name}</strong>)}
                                        {user.linkedin_url &&
                                            <a href={user.linkedin_url} target="_blank" rel="noreferrer"  > <LinkedInIcon color="primary" /></a>
                                        }
                                    </Typography>
                                </Grid>
                                {user.about !== 'None' && <Grid item xs={12} md={12}>
                                    <Typography
                                        component='h1'
                                        style={{
                                            fontSize: 18,
                                            fontFamily: 'Raleway',
                                        }}
                                    >
                                        {user.about}

                                    </Typography>
                                </Grid>
                                }
                                {user.skills.length > 0 && <Grid item xs={12} md={12}>
                                    <Typography
                                        component='h1'
                                        style={{
                                            fontSize: 15,
                                            fontFamily: 'Raleway',
                                        }}
                                    >
                                        Skills
                                    </Typography>
                                    {user.skills.map((skill, idx) => (
                                        <div key={idx} style={{ padding: '5px', display: 'inline-block' }}>
                                            <Chip label={skill} />
                                        </div>
                                    ))}
                                </Grid>
                                }
                            </Grid>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4}>
                            <img alt={'profile'} src={user.profile_pic} width='100%' />
                            <Grid item md={12} style={centerStyle}>
                                <Button
                                    onClick={() => { setOpen(true); selectedIndex(idx) }}
                                    id={user.first_name}
                                    value={user.first_name}
                                    style={{
                                        fontFamily: 'Raleway',
                                        backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                                        borderRadius: 30,
                                        color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                                    }}
                                >
                                    Request Time
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    }

    const DisplayDesktop = () => {
        return (
            <Grid>
                <Grid container spacing={2} style={centerStyle}>
                    <Grid item xs={12} md={12} style={centerStyle}>
                        <Typography variant='h2'>
                            Human Library
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} style={centerStyle}>
                        <Button
                            onClick={() => { window.location = '/human-library/requests' }}
                            style={{
                                fontFamily: 'Raleway',
                                backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                                borderRadius: 30,
                                color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                            }}
                        >
                            Your Requests
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={12} style={centerStyle}>
                        <Button
                            onClick={() => { window.location = '/edit/profile' }}
                            style={{
                                fontFamily: 'Raleway',
                                backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                                borderRadius: 30,
                                color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                            }}
                        >
                            Add Skills/LinkedIn to your Profile
                        </Button>
                    </Grid>
                    <Grid item xs={10} md={6}>
                        <TextField
                            fullWidth
                            size="medium"
                            onChange={(e) => { handleLoadMore(false, e.target.value) }}
                            style={{ borderRadius: 20 }}
                            label="Search"
                            variant="outlined"
                            id="searchId"
                        ></TextField>
                    </Grid>
                </Grid>
                <Grid container spacing={4} style={{ padding: '2vw' }}>
                    {allUsers.map((user, idx) => (
                        <UserCard user={user} idx={idx} key={idx} />
                    ))}
                </Grid>
                {/* <RequestTimeDialogBox allUsers={allUsers} formData={formData} index={index} reason={reason} submitHit={submitHit} loading={loading} open={open} Transition={Transition} locations={locations} options={options} handleClose={handleClose} updateFormData={updateFormData} handleFormChange={handleFormChange} handleInput={handleInput} handleSubmit={handleSubmit} /> */}

                {/* Dialog starts*/}
                <Grid item xs={6} md={12} style={{ boxShadow: '2px 2px 2px black' }}>
                    <Dialog
                        open={open}
                        TransitionComponent={Transition}
                        maxWidth="md"
                        BackdropProps={{ style: { backgroundColor: "transparent" } }}
                        onClose={handleClose} aria-labelledby="simple-dialog-title"
                    >
                        <DialogTitle>Request time from
                            {allUsers[index] && (allUsers[index].first_name !== allUsers[index].last_name ? (` ${allUsers[index].first_name} ${allUsers[index].last_name}`) : (` ${allUsers[index].first_name}`))}?
                        </DialogTitle>
                        <DialogContent style={{ height: isMobile ? '100%' : '20vh' }}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        multiline={true}
                                        required
                                        id="reason"
                                        name="reason"
                                        label="Reason for request"
                                        defaultValue={reason.current?.value}
                                        fullWidth
                                        inputRef={reason}
                                        value={reason.current?.value}
                                        error={(submitHit && !reason.current?.value) || (submitHit && reason.current?.value?.length === 0)}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel id="mutiple-select-label">Location</InputLabel>
                                    <KeyFillDropDown
                                        options={locations}
                                        required
                                        formData={formData}
                                        keyName="location"
                                        updateFormData={updateFormData}
                                        handleFormChange={handleFormChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} >
                                    <InputLabel id="mutiple-select-label">Prefered Days</InputLabel>
                                    <CreatableSelect
                                        defaultValue={[]}
                                        required
                                        isMulti
                                        isSearchable
                                        onChange={(e) => { handleInput({ target: { name: 'preferedDays', value: e } }) }}
                                        options={options}
                                        value={formData.preferedDays}
                                        error={submitHit && formData.preferedDays.length === 0}
                                        maxMenuHeight={isMobile ? '30vh' : '10vh'}
                                        isCreatable={false}
                                    />
                                </Grid>
                                <Grid item xs={8} md={4}>
                                    <TextField
                                        required
                                        label="How many hours would you like to request?"
                                        id="outlined-number"
                                        type="number"
                                        name="hoursRequested"
                                        value={formData.hoursRequested}
                                        onChange={handleInput}
                                        error={submitHit && formData.hoursRequested.length === 0}
                                    />
                                </Grid>
                                <Grid item xs={8} md={4}>
                                    <TextField
                                        id="preferedHoursStart"
                                        required
                                        name="preferedHoursStart"
                                        label="Prefered Time (Start)"
                                        type="time"
                                        defaultValue={formData.preferedHoursStart}
                                        inputProps={{
                                            step: 900, // 5 min
                                        }}
                                        error={submitHit && formData.preferedHoursStart.length === 0}
                                        onChange={handleInput}
                                        style={{ width: '100%' }}
                                    />
                                </Grid>
                                <Grid item xs={8} md={4}>
                                    <TextField
                                        id="preferedHoursEnd"
                                        label="Prefered Time (End)"
                                        type="time"
                                        name="preferedHoursEnd"
                                        defaultValue={formData.preferedHoursEnd}
                                        error={submitHit && formData.preferedHoursEnd.length === 0}
                                        onChange={handleInput}
                                        inputProps={{
                                            step: 900, // 5 min
                                        }}
                                        style={{ width: '100%' }}
                                    />
                                </Grid>
                            </Grid>

                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={handleClose}
                                disabled={loading}
                                style={{
                                    height: 40,
                                    fontFamily: 'Raleway',
                                    width: '6vw',

                                    backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                                    borderRadius: 30,
                                    color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleSubmit}
                                disabled={loading}
                                style={{
                                    height: 40,
                                    fontFamily: 'Raleway',
                                    width: '6vw',

                                    backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                                    borderRadius: 30,
                                    color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                                }}
                            >
                                Submit
                            </Button>
                            <div hidden={!loading}>
                                <CircularProgress color="inherit" />
                            </div>
                        </DialogActions>
                    </Dialog>
                </Grid>
                {/* Dialog end*/}
                <Grid item xs={12} md={12} style={centerStyle}>
                    <Button
                        onClick={() => handleLoadMore(true)}
                        style={{
                            fontFamily: 'Raleway',
                            backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                            borderRadius: 30,
                            color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                        }}
                    >
                        Load More
                    </Button>
                </Grid>
            </Grid >
        );
    }
    if (allUsers && !isLoading) {
        return <div>{DisplayDesktop()}</div>;
    } else if (isLoading) {
        return (
            <div style={{ marginTop: 20, textAlign: 'center' }}>
                <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
                <LinearProgress />
            </div>
        );
    }

}
